import * as React from "react";
const SvgFiRrHoneyPot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-honey-pot_svg__a)">
      <path
        fill="#062147"
        d="M21.618 2H22a1 1 0 0 0 0-2H2a1 1 0 0 0 0 2h.382C.907 4.278 0 7.184 0 9.905c0 4.213 2.637 9.206 3.771 11.156C4.824 22.874 6.803 24 8.934 24h6.134c2.131 0 4.109-1.126 5.163-2.938 1.134-1.951 3.771-6.943 3.771-11.157 0-2.721-.907-5.627-2.382-7.905zM18.5 20.057C17.803 21.255 16.488 22 15.067 22H8.933c-1.421 0-2.736-.745-3.433-1.944C3.309 16.285 2 12.491 2 9.905 2 7.133 3.133 4.016 4.85 2h.65C6.327 2 7 2.673 7 3.5V11a1 1 0 0 0 2 0V3.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V7a1 1 0 0 0 2 0V3.5c0-.827.673-1.5 1.5-1.5h3.65C20.867 4.016 22 7.132 22 9.905c0 2.585-1.309 6.38-3.5 10.152"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-honey-pot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHoneyPot;
